import { useState } from "react";
import { LogIn } from "lucide-react";
import { login, type AuthUser } from "../authClient";

export default function LoginPage({
  title,
  subtitle,
  requireRole,
  onSuccess,
}: {
  title: string;
  subtitle: string;
  requireRole?: "admin";
  onSuccess: (user: AuthUser) => void;
}) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setLoading(true);
    setError("");
    try {
      const user = await login(username.trim(), password);
      if (requireRole && user.role !== requireRole) {
        setError("该账号没有管理后台权限");
        setLoading(false);
        return;
      }
      onSuccess(user);
    } catch (err) {
      setError(err instanceof Error ? err.message : "登录失败");
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-header">
          <span className="logo-mark">临床方案平台</span>
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>

        <div className="form-group">
          <label className="form-label">用户名</label>
          <input
            className="form-input"
            type="text"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
          />
        </div>
        <div className="form-group">
          <label className="form-label">密码</label>
          <input
            className="form-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>

        {error && <p className="login-error">{error}</p>}

        <button className="btn btn-clay login-submit" type="submit" disabled={loading}>
          <LogIn size={16} className="icon" />
          <span>{loading ? "登录中…" : "登录"}</span>
        </button>
      </form>
    </div>
  );
}
